import { ReactNode } from 'react';
import { Button } from '@ets/design-system';

import styles from './Title.module.scss';

type BackToButtonProps = {
  children: ReactNode;
  onClick: () => void;
  testId: string;
};

const BackToButton = ({ children, testId, onClick }: BackToButtonProps) => {
  return (
    <div className={styles.container}>
      <Button
        size="m"
        variant="link"
        onClick={onClick}
        testId={`back-to-${testId}`}
        icon="chevron-left"
      >
        {children}
      </Button>
    </div>
  );
};

export default BackToButton;
